import type { RootState } from '~/redux/store';
import type { Sms } from '~/types/models';
import type { IRestIndexParams } from '~/types/states';

export const getParams = (state: RootState): IRestIndexParams<Sms> => ({
  sortBy: state.sms.sortBy,
  page: state.sms.page,
  pageSize: state.sms.pageSize,
  with: state.sms.with.join(','),
  ...state.sms.filters,
});

export const getItem = (state: RootState): Sms | null => state.sms.item;

export const getInitialItem = (state: RootState): string | null => state.sms.initialItem;
